import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

export function NewsFeedReachedEndState() {
  return (
    <Stack justifyContent="center" alignItems="center">
      <Text color={(theme) => theme.palette.text.tertiary}>
        You reached the end of your news feed
      </Text>
    </Stack>
  );
}
